import React from "react";
import IcoMoon from "react-icomoon";
import iconSet from "../icomoon.json";

const Icon = (props) => {
  // console.log(props);
  return <IcoMoon iconSet={iconSet} {...props} />;
};

export default Icon;
